const formParamNotificationWebhook = {
  deleteWebhook: 'Delete Webhook',
  deleteWebhookMessage: 'Do you really want to delete the webhook?',
  subtitle: 'Webhooks are used to enable communication between two applications and send almost real-time notifications.',
  invalidUrl: 'Invalid URL',
  showActionsLabel: 'Enable action notifications',
  actionsHelperText: 'Action notifications include: creation, editing, status change, and deletion.',
  actionsHelperText2: 'These will be sent with a POST request to {url} (e.g., https://geequip.sistemasgap.com.br/actions)',
  showServicesLabel: 'Enable service notifications',
  servicesHelperText: 'Service notifications include: creation, editing, and deletion.',
  servicesHelperText2: 'These will be sent with a POST request to {url} (e.g., https://geequip.sistemasgap.com.br/services)',
  createWebhook: 'Create Webhook',
  active: 'Active',
  apiKeyHelperText: 'The payloads delivered to your url will contain the header: {"x-api-key": {yourApiKey}}',
};

export default formParamNotificationWebhook;
